import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, fleetPath } from '@/lib/api-client';

import { fleetKeys } from './fleet-keys';

export interface DegradedIngress {
  name: string;
  reason: string;
  since: string;
}

/**
 * GET /admin/fleet/degraded-ingresses — current ingresses excluded from
 * the runtime selector because all their downstream EXIT_NODEs have lost
 * heartbeat. Populated by the fleet-exit-health-propagate worker; keys
 * carry a 90s TTL so this endpoint will be empty most of the time.
 *
 * Polled every 30s on screens that show it; the underlying worker runs
 * on a 60s cron so anything tighter is wasted load.
 */
export function useDegradedIngresses(): UseQueryResult<DegradedIngress[], Error> {
  return useQuery({
    queryKey: fleetKeys.degradedIngresses(),
    queryFn: async ({ signal }) => {
      const res = await apiClient.get<{ items: DegradedIngress[] }>(
        fleetPath('/degraded-ingresses'),
        signal,
      );
      return res.items;
    },
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
